import {
  getInputLabelsMap,
  getVersionFromDate,
} from '@/app/features/products/common/services';
import { InputLabelsMap } from '@ssar-app/domain';
import { ReactNode, useCallback, useEffect, useState } from 'react';

interface InputLabelsMapFetcherProps {
  subCode: string;
  onSuccess: (inputLabelsMap: InputLabelsMap, isLoading: boolean) => ReactNode;
  onError: (error: Error) => void;
}
export const InputLabelsMapFetcher = (props: InputLabelsMapFetcherProps) => {
  const { subCode, onError } = props;
  const [isLoading, setIsLoading] = useState(false);
  const { onSuccess: onSuccessResponse } = props;
  const [inputLabelsMap, setInputLabelsMap] = useState<InputLabelsMap>({});

  const getInputLabelsMapFn = useCallback(() => {
    setIsLoading(true);
    getVersionFromDate(Date.now())
      .then(async (res) => {
        const version = res.data as string;
        await getInputLabelsMap(version, subCode)
          .then((response) => {
            if (response.resultCode === 0) {
              if (response.data) {
                setInputLabelsMap(response.data);
              } else {
                if (onError) onError(new Error(`Invalid Version : ${version}`));
              }
            } else {
              if (onError)
                onError(
                  new Error(
                    `Error while fetching Input Labels Map: ${response.messages.join(
                      '\\n',
                    )}`,
                  ),
                );
            }
          })
          .catch((err) => {
            if (onError) onError(err);
          });
      })
      .catch((err) => {
        if (onError) onError(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (subCode) {
      getInputLabelsMapFn();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subCode]);

  return <>{onSuccessResponse(inputLabelsMap, isLoading)}</>;
};
